import { Component, inject, input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { Tooltip } from 'primeng/tooltip';
import { PackageFacade } from '@app/store/package';

@Component({
    selector: 'app-package-delete-button',
    templateUrl: './delete-button.component.html',
    styleUrls: ['./delete-button.component.css'],
    imports: [TranslateModule, ButtonModule, Tooltip],
})
export class DeleteButtonComponent {
    private readonly packageFacade = inject(PackageFacade);
    private readonly confirmationService = inject(ConfirmationService);
    private readonly translateService = inject(TranslateService);

    readonly packageId = input.required<string>();
    readonly saving = input<boolean>(false);
    readonly disabled = input<boolean>(false);
    readonly testId = input.required<string>();

    onDelete(): void {
        this.confirmationService.confirm({
            header: this.translateService.instant('packages.delete.header'),
            message: this.translateService.instant('packages.delete.message'),
            icon: 'pi pi-exclamation-triangle',
            rejectButtonProps: {
                label: this.translateService.instant('packages.delete.reject'),
                severity: 'secondary',
                outlined: true,
            },
            acceptButtonProps: {
                label: this.translateService.instant('packages.delete.accept'),
                severity: 'danger',
            },
            accept: () => {
                this.packageFacade.deletePackage(this.packageId());
            },
        });
    }
}
